import { Box, SimpleGrid, SlideFade } from '@chakra-ui/react';
import { PageContainer } from '@/components/PageContainer';
import { Footer } from '@/components/Footer';
import { SiteNav } from '@/components/Navbar/SiteNav';
import { PUBLIC_PAGE_CONTENT_PT } from '@/components/Navbar/siteNavLayout';
import { TeamDetailRoot } from '@/components/teamDetail';
import { useGroupStandings } from '@/hooks/useGroupStandings';
import { WORLD_CUP_GROUP_IDS, worldCupGroups } from '@/models/wc26Groups';
import { GroupCard } from './GroupCard';

export default function TeamsPage() {
  const groupStandings = useGroupStandings();

  return (
    <TeamDetailRoot>
      <SlideFade in>
        <PageContainer>
          <SiteNav />
          <Box as='main' width='full' pb={10}>
            <Box maxW='min(1400px, 100%)' mx='auto' px={{ base: 4, md: 8, xl: 12 }} pt={PUBLIC_PAGE_CONTENT_PT}>
              <SimpleGrid columns={{ base: 1, lg: 2, xl: 3 }} spacing={{ base: 5, md: 6, lg: 8 }}>
                {WORLD_CUP_GROUP_IDS.map((groupId) => (
                  <GroupCard
                    key={groupId}
                    groupId={groupId}
                    teams={worldCupGroups[groupId]}
                    standings={groupStandings?.groups[groupId]}
                  />
                ))}
              </SimpleGrid>
            </Box>
          </Box>
          <Footer />
        </PageContainer>
      </SlideFade>
    </TeamDetailRoot>
  );
}
